import { module as BaseModule } from "modujs"
import { load } from "recaptcha-v3"

export default class extends BaseModule {
  init() {
    this.submit = this.el.querySelector("[data-form-submit]")
    this.notice = this.el.querySelector("[data-form-notice]")
    this.fileInput = this.el.querySelector("input[type='file']")
    this.fileNameDisplay = this.el.querySelector("[data-file-name]")
    
    // Dev mode configuration
    this.devMode = false
    this.devData = {
      firstname: "John",
      lastname: "Doe",
      telephone: "+44 20 7123 4567",
      email: "changethis@email.com",
      message: "This is a test message for development purposes. I would like to inquire about your services and get more information about what you offer.",
      inquiry_type: "owner",
      contact_preference: "email"
    }
    
    this.listeners()
    this.initDevMode()
  }

  initDevMode() {
    if (this.devMode) {
      this.prefillForm()
      console.log("🔧 Dev mode enabled - Form pre-filled with sample data")
    }
  }

  prefillForm() {
    // Pre-fill text inputs
    const inputs = this.el.querySelectorAll("input[type='text'], input[type='tel'], input[type='email'], textarea")
    inputs.forEach(input => {
      const fieldName = input.name
      if (this.devData[fieldName]) {
        input.value = this.devData[fieldName]
        // Trigger the active state for styled inputs
        const fieldContainer = input.closest("[data-field]")
        if (fieldContainer) {
          fieldContainer.classList.add("active")
        }
      }
    })

    // Pre-select radio buttons
    const radioButtons = this.el.querySelectorAll("input[type='radio']")
    radioButtons.forEach(radio => {
      const fieldName = radio.name
      const fieldValue = radio.value
      if (this.devData[fieldName] === fieldValue) {
        radio.checked = true
      }
    })

  }

  listeners() {
    const fields = this.el.querySelectorAll("[data-field]")
    fields.forEach((element) => {
      const elements = element.querySelectorAll("input, textarea, label")
      elements.forEach((el) => {
        el.addEventListener("click", () => {
          element.classList.add("active")
        })
        el.addEventListener("focus", () => {
          element.classList.add("active")
        })

        el.addEventListener("blur", () => {
          if (el.value === "") element.classList.remove("active")
        })
      })
    })

      // Handle file input change
    if (this.fileInput) {
      this.fileInput.addEventListener("change", this.handleFileChange.bind(this))
    }

    this.el.addEventListener("submit", this.onSubmit.bind(this))
  }

  handleFileChange(e) {
    const file = e.target.files[0]
    if (file) {
      // Check file size (10MB limit for email attachments)
      const MB = 10
      const maxSize = MB * 1024 * 1024 // 10MB in bytes
      if (file.size > maxSize) {
        this.showError(`File size exceeds ${MB}MB limit for email attachments`)
        this.fileInput.value = ""
        this.fileNameDisplay.textContent = "No file chosen"
        return
      }

      // Check file type
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'text/plain',
        'image/jpeg',
        'image/jpg',
        'image/png'
      ]
      
      if (!allowedTypes.includes(file.type)) {
        this.showError("Invalid file type. Allowed: PDF, DOC, DOCX, TXT, JPG, PNG")
        this.fileInput.value = ""
        this.fileNameDisplay.textContent = "No file chosen"
        return
      }

      this.fileNameDisplay.textContent = file.name
    } else {
      this.fileNameDisplay.textContent = "No file chosen"
    }
  }


  showError(message) {
    this.notice.classList.remove("hidden")
    this.notice.innerHTML = message
    this.notice.style.borderColor = "#f87171" // red-400
    this.notice.style.backgroundColor = "#fef2f2" // red-50
  }

  async onSubmit(e) {
    try {
      e.preventDefault()
      if (this.isSent || this.isSending) return
      this.notice.classList.add("hidden")

      this.isSending = true
      this.submit.innerHTML = "Sending.."

      const recaptcha = await load("6Ld-f-grAAAAAIaQV1jchwSpm1HXGLZoqsoKqaCj")
      const token = await recaptcha.execute("form")

      const formData = new FormData(this.el)
      const data = {}
      const formDataArray = Array.from(formData)
      formDataArray.forEach(([key, value]) => {
        data[key] = value
      })
      data["token"] = token

            // Handle file attachment
            if (this.fileInput && this.fileInput.files[0]) {
              const file = this.fileInput.files[0]
              const reader = new FileReader()
              
              reader.onload = async (e) => {
                const base64Data = e.target.result.split(',')[1] // Remove data URL prefix
                data.attachment = {
                  name: file.name,
                  type: file.type,
                  data: base64Data
                }
                
                await this.sendFormData(data)
              }
              
              reader.readAsDataURL(file)
            } else {
              await this.sendFormData(data)
            }
            
    } catch (error) {
      console.log(error)
      this.showError("An error occurred. Please try again.")
      this.submit.innerHTML = "Send request"
      this.isSending = false
    }
  }

  async sendFormData(data) {
    try {
      const request = await fetch("/wp-json/custom/v1/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })

      const response = await request.json()
      const { status } = request
      const { message } = response

      if (status === 200) {
        this.onSuccess()
        this.isSent = true
        this.isSending = false
      } else {
        this.showError(message)
        this.submit.innerHTML = "Send request"
        this.isSending = false
      }
    } catch (error) {
      console.log(error)
      this.showError("An error occurred. Please try again.")
      this.submit.innerHTML = "Send request"
      this.isSending = false
    }
  }

  onSuccess() {
    this.submit.innerHTML = "Message sent!"
    this.submit.style.backgroundColor = "#10b981" // green-500
    this.submit.style.color = "white"
  }
}
